// @generated

import { decodeHex } from "../common/hex.js"

export default decodeHex(
"\
0061736d01000000012c0660017f0060037f7f7f0060027f7f0060057f7f7f7f\
7f0060067f7f7f7f7f7f0060087f7f7f7f7f7f7f7f00029e010704686f737406\
6d656d6f7279020001066b656363616b0c6b656363616b5f6631363030000009\
72697374726574746f0f753531325f6d6f645f7363616c617200000972697374\
726574746f0963757276655f706f7700010972697374726574746f0b72697374\
5f656e636f646500020972697374726574746f0a7363616c61725f6d756c0002\
0972697374726574746f0a7363616c61725f6164640002030d0c030303020101\
01020400050206e201297f0041e00c0b7f00410b0b7f0041eb0c0b7f0041ef0c\
0b7f0041070b7f0041f60c0b7f00410e0b7f0041840d0b7f00410a0b7f00418e\
0d0b7f00410a0b7f0041980d0b7f00410b0b7f0041a60d0b7f0041070b7f0041\
ad0d0b7f0041060b7f0041b30d0b7f0041060b7f0041c20d0b7f0041030b7f00\
41c50d0b7f0041c5110b7f0041c5130b7f0041c5150b7f0041c5170b7f0041c5\
190b7f0041070b7f0041cc190b7f0041a01f0b7f0041010b7f0041020b7f0041\
040b7f0041080b7f0041100b7f0041200b7f0041240b7f0041120b7f0041060b\
7f0041070b7f0041a6010b072e040e726973745f62617365706f696e74031908\
667265655f616472031d047369676e0010076765745f70756200110c010c0ad1\
070c320020002325100920020440200020012002100a0b230220043602002000\
23024104100a2000231f1009200020032004100a0b2d00200023251009200020\
012002100a23022004360200200023024104100a200023261009200020032004\
100b0b320020002325100920020440200020012002100a0b2302200436020020\
0023024104100a200023271009200020032004100c0b7f01037f20002d00c901\
210420002d00c80121022000200241016a3a00c901200220006a220320032d00\
002004733a0000200241016a2202232846044020002002100d410021020b2002\
20006a220320032d00002001733a0000200241016a2202232846200123247172\
044020002002100d410021020b200020023a00c8010b5601037f200120026a21\
0320002d00c80121040340200420006a220520052d000020012d0000733a0000\
200441016a2204232846044020002004100d410021040b200141016a22012003\
490d000b200020043a00c8010b4e01027f200120026a210320002d00c8012104\
0340200420006a20012d00003a0000200441016a220423284604402000200410\
0d410021040b200141016a22012003490d000b200020043a00c8010b5801027f\
200120026a210320002d00c801210403402001200420006a2d00003a00002004\
20006a41003a0000200441016a2204232846044020002004100d410021040b20\
0141016a22012003490d000b200020043a00c8010b3a01017f200020016a2202\
20022f010020002f01c90141800872733b0100200020002d00a701418001733a\
00a70120001000200041003b01c8010b5a00200041004112fc080b0020001000\
200023251009200023002301100a200023032304230523061006200041004100\
20012002100620002307230820032004100620002309230a230b230c10062000\
231a231b2005412010060b5201017e2000200029031822014203883703182000\
2001423d86200029031022014203888437031020002001423d86200029030822\
014203888437030820002001423d8620002903002201420388843703000bbd01\
01017f2005100f200741206a2108231720002001200220032004100e23182317\
418002fc0a00002318230d230e200541206a4120100723182325100923182313\
2314100a231823261009231820064120100b231841004100231541c000100823\
15100123162319231510022007231610032317230f2310200741201006231723\
112312231c41c0001008231c10012008231c4120fc0a00002008200510042008\
23151005200720072d003f418001723a003f2315410041800afc0b000b140020\
00100f23162319200010022001231610030b0bb3010c0041e00c0b0b4d65726c\
696e2076312e300041ef0c0b07646f6d2d7365700041f60c0b0e5369676e696e\
67436f6e746578740041840d0b0a7369676e2d627974657300418e0d0b0a7072\
6f746f2d6e616d650041980d0b0b5363686e6f72722d7369670041a60d0b0773\
69676e696e670041ad0d0b067369676e3a520041b30d0b067369676e3a630041\
c20d0b03726e670041c5190b077369676e3a706b011201a8010001605354524f\
424576312e302e32\
",
)
